import { useState } from 'react';

export default function usePopper() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const onOpen = (
    e: any,
  ) => setAnchorEl(e && e.currentTarget); // Set to any for now, should change later
  const onClose = () => setAnchorEl(null);
  return {
    anchorEl,
    open,
    onOpen,
    onClose,
  };
}
